'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var GeojsonBuilder = function GeojsonBuilder() {
  'ngInject';

  return {
    getGeojson: getGeojson
  };

  function getGeojson(geojsonArry) {
    var geoJson = {
      'type': 'FeatureCollection',
      'features': [{
        'type': 'Feature',
        'properties': {},
        'geometry': {
          'type': 'MultiLineString',
          'coordinates': [[]]
        }
      }]
    };
    geoJson.features[0].geometry.coordinates[0] = geojsonArry;
    return geoJson;
  }
};
exports.default = GeojsonBuilder;


// WEBPACK FOOTER //
// ./client/app/services/geojsonBuilder/geojsonBuilder.service.js